/* eslint-disable no-param-reassign */
import SEOModel from 'models/SEO.model';
import { BLOG_SETTINGS } from 'common/consts/blog';

export const extractTextFromTags = textWithTags => textWithTags.replace(/(<([^>]+)>)/ig, '');

export const limitArticleChars = (article, limit) => `
  ${extractTextFromTags(article).slice(0, limit)}...
`;

export const limitArticleCharsWithoutWordCut = (article, limit) => {
  const articleText = extractTextFromTags(article);
  const indexOfLastSpace = articleText.slice(0, limit).lastIndexOf(' ');
  return articleText.slice(0, indexOfLastSpace);
};

export const addNewMetaTagsToExistingMetaTagsString = (currentMetaTags, newMetaTags) => {
  const metaTagsArray = currentMetaTags.replace(/\s/g, '').split(',').filter(tag => tag !== '');
  const newMetaTagsArray = newMetaTags.replace(/\s/g, '').split(',').filter(tag => tag !== '');
  metaTagsArray.push(...newMetaTagsArray);
  return Array.from(new Set(metaTagsArray)).join(', ');
};

export const generateMetaTagsFromBlogArticle = (blogArticle) => {
  const SEO = blogArticle.SEO || new SEOModel();

  if (!SEO.title) {
    SEO.title = blogArticle.title;
  }
  if (!SEO.description) {
    SEO.description = limitArticleCharsWithoutWordCut(
      blogArticle.content.value,
      BLOG_SETTINGS.ARTICLE_SEO_DESCRIPTION_LIMIT,
    );
  }
  if (!SEO.ogImage) {
    SEO.ogImage = blogArticle.listingImage;
  }
  if (!SEO.ogType) {
    SEO.ogType = 'article';
  }
  if (SEO.metaKeywords) {
    SEO.metaKeywords = addNewMetaTagsToExistingMetaTagsString(
      SEO.metaKeywords,
      blogArticle.metaKeywords,
    );
  } else {
    SEO.metaKeywords = blogArticle.metaKeywords;
  }
  return SEO;
};



// WEBPACK FOOTER //
// ./src/common/methods/blogMethods.js